import { credgrpdata } from "./table_typing"

export interface tableState {
    model:{
            user:credgrpdata[],
        }
    view:{
        loaded: boolean, 
        autorefresh: boolean,
    }
}

export const tableInitialState = {
    model:{
        user: [] as credgrpdata[]
        }
        ,
        view:{
            loaded: false,
            autorefresh: false,
        }
    }


export function deepCopyTableThingyState(toCopy:tableState):tableState{
    return {
        model:{
            user:toCopy.model.user.map((user) =>
            {
                return {
                    ...user,
                }
            })
        },
        view:{
            loaded:toCopy.view.loaded,
            autorefresh:toCopy.view.autorefresh
        }
    }
    
}